import { EnrollmentExperienceResponse } from "@/api/types";

export interface EnrollmentState {
  readonly experienceData: EnrollmentExperienceResponse;
  readonly isLoading: boolean;
}


export const ENROLLMENT_DEFAULT_STATE: EnrollmentState = {
  experienceData: {
    is_premium: false,
  } as EnrollmentExperienceResponse,
  isLoading: true,
};
